module.exports = __webpack_public_path__ + "static/media/flamingo-upsp.d25baef2.jpg";